export default __webpack_public_path__ + "static/media/banner2.f2bf9aa9.jpg";